/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_1_2 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [-3.1233676128251164, 56.030618881574775],
                        [-3.4296115093094914, 56.030618881574775],
                        [-3.4296115093094914, 55.91765706389119],
                        [-3.1233676128251164, 55.91765706389119],
                        [-3.1233676128251164, 56.030618881574775]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_1_2